import { AppVariantConfig } from '@/types/app-config';

export const teamsVariant: AppVariantConfig = {
  id: 'teams',
  name: 'Teams',
  description: 'Team collaboration with groups and communication tools',
  defaultRoute: 'directory',
  appModules: {
    directory: { enabled: true },
    groups: { 
      enabled: true, 
      requiresFeature: 'groups.blog' 
    },
    portal: { 
      enabled: true, 
      requiresFeature: 'portal',
      subModules: {
        events: { enabled: true, requiresFeature: 'events' },
        mail: { enabled: true, requiresFeature: 'mail' },
        channels: { enabled: true, requiresFeature: 'channels' }
      }
    }
  },
  adminModules: {
    users: { enabled: true },
    groups: { enabled: true },
    events: { enabled: true },
    mail: { enabled: true },
    channels: { enabled: true },
    settings: { enabled: true },
    design: { enabled: true },
    onboarding: { enabled: true }
  }
}; 